module.exports = __webpack_public_path__ + "static/fmw-27b0142b47c58ef8a0d8de389207138a.jpg";